import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import tickIcon from "src/assets/images/checked-icon-modal.png";

interface DrawerProps {
  onClose: () => void;
  children: React.ReactNode;
  isOpen: boolean;
  className?: string;
  showModal?: boolean;
  modalContent?: {
    title?: string;
    description?: string;
    buttonText?: string;
    onButtonClick?: () => void;
    icon?: string;
    titleClass?: string;
    descriptionClass?: string;
  };
  drawerClassNames?: string;
  alwaysShow?: boolean;
  disableSideClick?: boolean;
}

const CartDrawer: React.FC<DrawerProps> = ({
  onClose,
  children,
  isOpen,
  className,
  showModal = false,
  modalContent,
  drawerClassNames,
  alwaysShow = false,
  disableSideClick = false,
}) => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenNew, setIsModalOpenNew] = useState(false);
  const transitionDuration = 500;
  const transitionRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (showModal) {
      setIsModalOpen(true);
    } else {
      setIsModalOpen(false);
    }
  }, [showModal]);

  useEffect(() => {
    if (isOpen) {
      if (transitionRef.current) {
        clearTimeout(transitionRef.current);
      }
      setIsModalOpenNew(true);
      document.body.classList.add("overflow-hidden", "md:pr-[8px]");
    } else {
      if (transitionRef.current) {
        clearTimeout(transitionRef.current);
      }
      transitionRef.current = setTimeout(() => {
        setIsModalOpenNew(false);
        document.body.classList.remove("overflow-hidden", "md:pr-[8px]");
      }, transitionDuration);
    }
  }, [isOpen]);

  return (
    <>
      {isModalOpen && isOpen && (
        <div className="modal-stripe-overlay z-[1001]" style={{}}>
          <div className="modal-stripe p-6 bg-modal-image">
            <div className="password-update-success">
              <img src={modalContent?.icon || tickIcon} alt="" />
            </div>
            <h2
              className={`text-[#2F2F31] leading-tight font-size-30px font-Lexend-Medium text-center ${modalContent?.titleClass}`}
            >
              {modalContent?.title}
            </h2>

            <p
              className={`text-[#2F2F31] font-Poppins-Medium font-size-19px px-3 pt-1 pb-2 cursor-pointer ${modalContent?.descriptionClass}`}
            >
              {modalContent?.description}
            </p>

            <button
              onClick={() => {
                if (modalContent?.onButtonClick) {
                  modalContent?.onButtonClick();
                } else {
                  navigate("/");
                  onClose();
                }
              }}
              className="back-to-home-btn text-white font-size-20px font-Poppins-Medium"
              id="back-to-home-button"
            >
              {modalContent?.buttonText || "Back To Home"}
            </button>
          </div>
        </div>
      )}
      {/* Overlay */}
      <div
        onClick={disableSideClick ? undefined : onClose}
        className={`fixed inset-0 bg-black bg-opacity-50 z-[999] transition-opacity duration-300 ease-in-out ${
          isOpen
            ? "opacity-100 pointer-events-auto"
            : "opacity-0 pointer-events-none"
        }`}
      />
      <div
        className={`fixed top-0 right-0 w-full md:max-w-[30vw] xl:max-w-[30vw] 2xl:max-w-[29vw] min-w-[350px] max-w-[500px] h-full bg-white shadow-[-2px_0px_5px_rgba(0,0,0,0.3)] z-[1000] overflow-y-auto transform transition-transform ease-in-out ${
          isOpen ? "translate-x-0" : "translate-x-[102%]"
        } ${className}`}
        style={{ transitionDuration: transitionDuration + "ms" }}
      >
        <div className="w-full h-full relative">
          <div
            className="h-screen flex flex-col overflow-y-auto"
            id="sidebar-scroll-container"
          >
            {isModalOpenNew || alwaysShow ? children : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default CartDrawer;
